export const TRUCK_TYPES = ["Dry Van", "Flatbed", "Reefer", "Stepdeck", "Conestoga", "Power Only", "RGN", "Hotshot 40ft"];
export const LEAD_STATUSES = ["Qualified", "Follow-up", "Sent for Final Approval", "Approved", "OPI - Carrier Packet Sent", "OPI Completed", "Ready for Dispatch", "Carrier Activated", "Risk Rejected"];
export const AUTO_STAGES = ["OPI - Carrier Packet Sent", "OPI Completed", "Carrier Activated"];
export const REJECTED_STATUSES = ["rejected", "Risk Rejected"];
export const DISPATCH_PLANS = [5, 3.75, 3, 2.75, 2.5];

// Forward funnel order (Risk Rejected is an off-ramp, not a step).
export const LEAD_PIPELINE = [
  { key: "Qualified", short: "Qualified", color: "#38bdf8" },
  { key: "Follow-up", short: "Follow-up", color: "#60a5fa" },
  { key: "Sent for Final Approval", short: "Final Approval", color: "#818cf8" },
  { key: "Approved", short: "Approved", color: "#a78bfa" },
  { key: "OPI - Carrier Packet Sent", short: "OPI Sent", color: "#f59e0b" },
  { key: "OPI Completed", short: "OPI Completed", color: "#14b8a6" },
  { key: "Ready for Dispatch", short: "Ready for Dispatch", color: "#10b981" },
  { key: "Carrier Activated", short: "Activated", color: "#059669" },
];
export const STATUS_SHORT = Object.fromEntries([...LEAD_PIPELINE.map((s) => [s.key, s.short]), ["Risk Rejected", "Risk Rejected"]]);
export const STATUS_COLORS = { ...Object.fromEntries(LEAD_PIPELINE.map((s) => [s.key, s.color])), "Risk Rejected": "#ef4444" };
// Statuses from which an admin may convert a lead into an Active Carrier.
export const CARRIER_READY_STATUSES = ["Ready for Dispatch"];
export const RISK_TYPES = [
  "Double Brokering Suspicion", "Identity / Fraud Concern", "New Authority (Under 90 Days)", "Insurance Issue / Lapse",
  "Authority Inactive or Revoked", "Poor Safety Rating / CSA Scores", "Out-of-Service Orders", "Unverifiable Contact Info",
  "Credit / Payment Risk", "Carrier Backed Off", "Other",
];

// Stage SLA: a lead is "stuck" if it sits in a non-terminal stage past this many days.
export const SLA_DAYS = 3;
export function leadStuckDays(lead) {
  if (!lead || !lead.stage_changed_at) return 0;
  if (REJECTED_STATUSES.includes(lead.status) || lead.carrier_id) return 0;
  return Math.floor((Date.now() - new Date(lead.stage_changed_at).getTime()) / 86400000);
}
export const isLeadStuck = (lead) => leadStuckDays(lead) >= SLA_DAYS;
export const SUITABLE_PLANS = [
  "Business Plan - 5%",
  "Enterprises Plan - 3.75%",
  "Empire Plan - 2.75%",
  "Special Offer - 3%",
];
export const leadEmpty = {
  company: "", owner_manager: "", contact_name: "", email: "", phone: "", address: "",
  mc_number: "", usdot: "", truck_types: [], num_trucks: 0, expected_gross_weekly: 0,
  carrier_requirement: "", suitable_plan: "", additional_package: false,
  estimated_value: 0, conversion_possibility: 50, status: "Qualified",
  source: "", notes: "", rejection_reason: "", assigned_to: "",
};
